"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRichTextStructure = exports.isRichTextNewLineNode = exports.isRichTextCodeBlock = exports.isRichTextListNode = exports.isRichTextTextNode = exports.isRichTextLinkNode = exports.isRichTextListItemType = exports.getRichTextBlockType = exports.RICH_TEXT_INLINE_STYLE_MAP = exports.plainRichText = exports.RICH_TEXT_TOKENS = exports.RICH_TEXT_INLINE_STYLE = exports.RICH_TEXT_LIST = exports.RICH_TEXT_CODE_BLOCK_TYPE = exports.RICH_TEXT_MULTILINE_BLOCK = exports.RICH_TEXT_BLOCK_PREFIX = exports.RichTextStyle = exports.RichTextListType = exports.RichTextListItemType = exports.RichTextBlockType = void 0;
const utils_1 = require("@obvio/utils");
var RichTextBlockType;
(function (RichTextBlockType) {
    RichTextBlockType["H2"] = "header-two";
    RichTextBlockType["H3"] = "header-three";
    RichTextBlockType["P"] = "unstyled";
    RichTextBlockType["QUOTE"] = "blockquote";
    RichTextBlockType["CODEBLOCK"] = "code-block";
})(RichTextBlockType = exports.RichTextBlockType || (exports.RichTextBlockType = {}));
var RichTextListItemType;
(function (RichTextListItemType) {
    RichTextListItemType["OL"] = "ordered-list-item";
    RichTextListItemType["UL"] = "unordered-list-item";
})(RichTextListItemType = exports.RichTextListItemType || (exports.RichTextListItemType = {}));
var RichTextListType;
(function (RichTextListType) {
    RichTextListType["OL"] = "ordered-list";
    RichTextListType["UL"] = "unordered-list";
})(RichTextListType = exports.RichTextListType || (exports.RichTextListType = {}));
var RichTextStyle;
(function (RichTextStyle) {
    RichTextStyle["BOLD"] = "BOLD";
    RichTextStyle["ITALIC"] = "ITALIC";
    RichTextStyle["UNDERLINE"] = "UNDERLINE";
    RichTextStyle["STRIKE"] = "STRIKETHROUGH";
    RichTextStyle["CODE"] = "CODE";
    RichTextStyle["F1"] = "FONT-1";
    RichTextStyle["F2"] = "FONT-2";
})(RichTextStyle = exports.RichTextStyle || (exports.RichTextStyle = {}));
exports.RICH_TEXT_BLOCK_PREFIX = {
    [RichTextBlockType.H3]: '##',
    [RichTextBlockType.H2]: '#',
    [RichTextBlockType.QUOTE]: '>',
};
exports.RICH_TEXT_MULTILINE_BLOCK = {
    [RichTextBlockType.CODEBLOCK]: '```',
};
exports.RICH_TEXT_CODE_BLOCK_TYPE = exports.RICH_TEXT_MULTILINE_BLOCK[RichTextBlockType.CODEBLOCK];
exports.RICH_TEXT_LIST = {
    [RichTextListItemType.OL]: 'n.',
    [RichTextListItemType.UL]: '-',
};
const CUSTOM_RICH_TEXT_INLINE_STYLE = {
    [RichTextStyle.F1]: '<F1>',
    [RichTextStyle.F2]: '<F2>',
};
exports.RICH_TEXT_INLINE_STYLE = Object.assign({ [RichTextStyle.BOLD]: '*', [RichTextStyle.ITALIC]: '/', [RichTextStyle.UNDERLINE]: '_', [RichTextStyle.STRIKE]: '~', [RichTextStyle.CODE]: '`' }, CUSTOM_RICH_TEXT_INLINE_STYLE);
exports.RICH_TEXT_TOKENS = Object.values(Object.assign(Object.assign(Object.assign(Object.assign({}, exports.RICH_TEXT_BLOCK_PREFIX), exports.RICH_TEXT_MULTILINE_BLOCK), exports.RICH_TEXT_LIST), exports.RICH_TEXT_INLINE_STYLE));
function plainRichText(richText) {
    return (function mapBlocks(blocks) {
        return blocks
            .map((block) => isRichTextListNode(block)
            ? mapBlocks(block.children).replaceAll(/^/gmu, '- ')
            : 'children' in block
                ? block.children
                    .flatMap((child) => isRichTextLinkNode(child)
                    ? `[${child.children.map((node) => node.text).join('')}]`
                    : isRichTextListNode(child)
                        ? mapBlocks(child.children)
                        : child.text)
                    .join('')
                : '')
            .join('\n');
    })(getRichTextStructure(richText));
}
exports.plainRichText = plainRichText;
exports.RICH_TEXT_INLINE_STYLE_MAP = (0, utils_1.keys)(exports.RICH_TEXT_INLINE_STYLE).reduce((acc, style) => Object.assign(acc, { [exports.RICH_TEXT_INLINE_STYLE[style]]: style }), {});
function getRichTextBlockType(textBlock) {
    const listType = (0, utils_1.keys)(exports.RICH_TEXT_LIST).find((key) => textBlock.trim().startsWith(exports.RICH_TEXT_LIST[key]));
    if (listType) {
        return listType;
    }
    const blockPrefixKeys = (0, utils_1.keys)(exports.RICH_TEXT_BLOCK_PREFIX);
    blockPrefixKeys.sort((k1, k2) => (0, utils_1.descSort)(exports.RICH_TEXT_BLOCK_PREFIX[k1].length, exports.RICH_TEXT_BLOCK_PREFIX[k2].length));
    const blockType = blockPrefixKeys.find((key) => textBlock.startsWith(exports.RICH_TEXT_BLOCK_PREFIX[key]));
    if (blockType) {
        return blockType;
    }
    return RichTextBlockType.P;
}
exports.getRichTextBlockType = getRichTextBlockType;
function isRichTextListItemType(type) {
    return (0, utils_1.values)(RichTextListItemType).includes(type);
}
exports.isRichTextListItemType = isRichTextListItemType;
function isRichTextLinkNode(node) {
    return typeof (node === null || node === void 0 ? void 0 : node.url) === 'string';
}
exports.isRichTextLinkNode = isRichTextLinkNode;
function isRichTextTextNode(node) {
    return typeof (node === null || node === void 0 ? void 0 : node.text) === 'string';
}
exports.isRichTextTextNode = isRichTextTextNode;
function isRichTextListNode(node) {
    return (0, utils_1.values)(RichTextListType).includes(node === null || node === void 0 ? void 0 : node.type);
}
exports.isRichTextListNode = isRichTextListNode;
function isRichTextCodeBlock(node) {
    return (0, utils_1.keys)(exports.RICH_TEXT_MULTILINE_BLOCK).includes(node === null || node === void 0 ? void 0 : node.type);
}
exports.isRichTextCodeBlock = isRichTextCodeBlock;
function isRichTextNewLineNode(node) {
    return (node === null || node === void 0 ? void 0 : node.type) === 'new-line';
}
exports.isRichTextNewLineNode = isRichTextNewLineNode;
const LIST_ITEM_BLOCK_MAP = {
    [RichTextListItemType.OL]: RichTextListType.OL,
    [RichTextListItemType.UL]: RichTextListType.UL,
};
const LIST_BLOCK_ITEM_MAP = {
    [RichTextListType.OL]: RichTextListItemType.OL,
    [RichTextListType.UL]: RichTextListItemType.UL,
};
function getRichTextStructure(richText) {
    if (!(richText === null || richText === void 0 ? void 0 : richText.trim())) {
        return [];
    }
    const textBlocks = richText.split('\n');
    let multilineBlock;
    const blocks = [];
    textBlocks.forEach((textBlock) => {
        var _a, _b;
        const multilineType = (0, utils_1.keys)(exports.RICH_TEXT_MULTILINE_BLOCK).find((key) => exports.RICH_TEXT_MULTILINE_BLOCK[key] === textBlock);
        if (multilineType) {
            multilineBlock = multilineBlock ? undefined : multilineType;
            return;
        }
        const blockType = multilineBlock || getRichTextBlockType(textBlock);
        const type = isRichTextListItemType(blockType)
            ? LIST_ITEM_BLOCK_MAP[blockType]
            : blockType;
        let block = {
            type,
            children: [],
        };
        let targetBlock;
        const prevBlock = (0, utils_1.last)(blocks);
        if (isRichTextCodeBlock(block)) {
            if ((prevBlock === null || prevBlock === void 0 ? void 0 : prevBlock.type) === block.type) {
                block = prevBlock;
            }
            else {
                blocks.push(block);
            }
        }
        if (isRichTextListNode(block)) {
            const depth = (_b = (_a = /^( *)/u.exec(textBlock)) === null || _a === void 0 ? void 0 : _a[0].length) !== null && _b !== void 0 ? _b : 0;
            const isNewList = !prevBlock || (depth === 0 && prevBlock.type !== type);
            const isContinuation = isRichTextListNode(prevBlock) && !isNewList;
            if (isContinuation) {
                block = prevBlock;
            }
            else {
                blocks.push(block);
            }
            const itemType = LIST_BLOCK_ITEM_MAP[block.type];
            targetBlock = putNewListItemNode(block, depth, itemType);
        }
        else {
            targetBlock = block;
        }
        let text = ((0, utils_1.has)(exports.RICH_TEXT_LIST, blockType)
            ? textBlock.trim().replace(exports.RICH_TEXT_LIST[blockType], '')
            : (0, utils_1.has)(exports.RICH_TEXT_BLOCK_PREFIX, blockType)
                ? textBlock.replace(exports.RICH_TEXT_BLOCK_PREFIX[blockType], '')
                : textBlock).trim();
        if (isRichTextCodeBlock(targetBlock)) {
            text = textBlock.replace(/^\\```/u, '```');
            const lastChild = (0, utils_1.last)(targetBlock.children);
            if (isRichTextTextNode(lastChild)) {
                lastChild.text += `\n${text}`;
            }
            else {
                targetBlock.children.push({ text, styles: [] });
            }
        }
        else {
            const chars = [...text];
            let i = 0;
            let escaped = false;
            let chunk = '';
            const openStyles = {};
            let linkNode;
            let linkChildren;
            const closeChunk = () => {
                if (chunk.length > 0) {
                    ;
                    (linkChildren !== null && linkChildren !== void 0 ? linkChildren : targetBlock.children).push({
                        text: chunk,
                        styles: (0, utils_1.keys)((0, utils_1.omit)(openStyles, 'LINK')),
                    });
                    chunk = '';
                }
            };
            for (let index = 0; index < chars.length; index++) {
                const char = chars[index];
                if (char !== '\\' || escaped) {
                    if (escaped) {
                        if (linkNode) {
                            linkNode.url += char;
                        }
                        else {
                            chunk += char;
                            i += 1;
                        }
                        escaped = false;
                    }
                    else {
                        switch (char) {
                            case '[': {
                                closeChunk();
                                linkChildren = [];
                                openStyles.LINK = i;
                                break;
                            }
                            case '(': {
                                closeChunk();
                                linkNode = { url: '', children: linkChildren !== null && linkChildren !== void 0 ? linkChildren : [] };
                                linkChildren = undefined;
                                break;
                            }
                            case ')': {
                                if (linkNode) {
                                    targetBlock.children.push(linkNode);
                                }
                                linkNode = undefined;
                                linkChildren = undefined;
                                delete openStyles.LINK;
                                break;
                            }
                            default: {
                                if (char !== ']') {
                                    if (linkNode) {
                                        linkNode.url += char;
                                    }
                                    else if (char === '<') {
                                        const rest = chars.slice(index);
                                        const closestClosing = rest.indexOf('>');
                                        if (closestClosing === -1) {
                                            chunk += char;
                                            i += 1;
                                            break;
                                        }
                                        const tag = rest.slice(0, closestClosing + 1).join('');
                                        const style = exports.RICH_TEXT_INLINE_STYLE_MAP[tag];
                                        if (!style) {
                                            chunk += char;
                                            i += 1;
                                            break;
                                        }
                                        const offset = openStyles[style];
                                        if (typeof offset === 'number') {
                                            closeChunk();
                                            delete openStyles[style];
                                        }
                                        else {
                                            openStyles[style] = i;
                                        }
                                        index += closestClosing;
                                    }
                                    else {
                                        const style = exports.RICH_TEXT_INLINE_STYLE_MAP[char];
                                        if (style) {
                                            const offset = openStyles[style];
                                            if (typeof offset === 'number') {
                                                closeChunk();
                                                delete openStyles[style];
                                            }
                                            else {
                                                openStyles[style] = i;
                                            }
                                        }
                                        else {
                                            chunk += char;
                                            i += 1;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    escaped = true;
                }
            }
            closeChunk();
        }
        if (block !== (0, utils_1.last)(blocks)) {
            const { children: [node, ...rest], } = block;
            const isEmpty = rest.length === 0 && isRichTextTextNode(node) && node.text.trim() === '';
            blocks.push(isEmpty ? { type: 'new-line' } : block);
        }
    });
    return blocks;
}
exports.getRichTextStructure = getRichTextStructure;
function putNewListItemNode(block, depth, type) {
    let listBlock = block;
    let listDepth = depth;
    while (listDepth > 0) {
        let lastItem = (0, utils_1.last)(listBlock.children);
        if (!lastItem) {
            lastItem = {
                type: LIST_BLOCK_ITEM_MAP[listBlock.type],
                children: [],
            };
            listBlock.children.push(lastItem);
        }
        const childBlock = (0, utils_1.last)(lastItem.children);
        if (isRichTextListNode(childBlock)) {
            listBlock = childBlock;
        }
        else {
            listBlock = {
                type: LIST_ITEM_BLOCK_MAP[type],
                children: [],
            };
            lastItem.children.push(listBlock);
        }
        listDepth -= 1;
    }
    const listItem = { type, children: [] };
    listBlock.children.push(listItem);
    return listItem;
}
